import { useStyles } from "./RCALibraryDescriptionCell.styles";
import { IRCALibraryDescriptionCell } from "./RCALibraryDescriptionCellInterfaces";
import { truncateLongText } from "utilities/utilities";
import { useCharFit } from "hooks/useCharFit";

const RCALibraryDescriptionCell = ({ rca }: IRCALibraryDescriptionCell) => {
    const classes = useStyles();
    const { cellRef, charsThatCanFit } = useCharFit();

    return (
        <div ref={cellRef} className={classes.descriptionWrapper}>
            <span className={classes.text}>{truncateLongText(rca.incident_description, charsThatCanFit)}</span>
        </div>
    );
};

export default RCALibraryDescriptionCell;
